import apiClient from '@shared/api/apiClient';

/**
 * 부서 리스트 조회
 * @param {number} companyId - 조회할 회사 ID
 * @returns {Promise<Object>} 서버 응답 데이터
 */
async function getTeam(companyId) {
  const response = await apiClient.get(`/v1/users/teams/${companyId}`, { withAuth: true });
  return response.data;
}
export default getTeam;

/**
 * 팀 상세 정보 조회
 * @param {number} teamCode - 팀(부서) 코드
 * @param {boolean} [toHtml=false] - HTML 변환 여부 (선택)
 * @returns {Promise<Object>} 서버 응답 데이터
 */
export async function getTeamInfo(teamCode, toHtml = false) {
  if (!teamCode) {
    throw new Error('getTeamInfo: teamCode는 필수 값입니다.');
  }

  const response = await apiClient.get(`/v1/organizations/teams/${teamCode}`, {
    withAuth: true,
    params: toHtml ? { toHtml } : undefined,
  });

  return response.data;
}

/**
 * admin 부서 수정
 * @param {Object} teamData - 부서 수정 정보 (RequestTeamDataDTO)
 * @returns {Promise<Object>} 서버 응답 데이터
 */
export async function updateTeam(teamData) {
  if (!teamData?.teamCode || !teamData?.company || !teamData?.name) {
    throw new Error('updateTeam: 필수 값(teamCode, company, name)이 누락되었습니다.');
  }

  const payload = {
    ...teamData,

    // MyBatis <choose> 조건 대응 (확실)
    manager: teamData.manager > 0 ? teamData.manager : 0,
    department: teamData.department > 0 ? teamData.department : 0,

    // senderList 정규화
    senderList:
      Array.isArray(teamData.senderList) && teamData.senderList.length > 0
        ? teamData.senderList
        : null,
  };

  const response = await apiClient.put('/v1/organizations/teams', payload, { withAuth: true });

  return response.data;
}
/**
 * admin 부서 추가
 * @param {Object} teamData - 부서 추가 정보 (RequestTeamDataDTO)
 * @returns {Promise<Object>} 서버 응답 데이터
 */
export async function addTeam(teamData) {
  console.log(teamData);
  if (!teamData?.company || !teamData?.name) {
    throw new Error('addTeam: 필수 값(company, name)이 누락되었습니다.');
  }

  const payload = {
    ...teamData,

    // MyBatis <choose> 조건 대응 (updateTeam과 동일한 패턴)
    manager: teamData.manager > 0 ? teamData.manager : 0,
    department: teamData.department > 0 ? teamData.department : 0,

    // senderList 정규화 (존재할 경우만)
    senderList:
      Array.isArray(teamData.senderList) && teamData.senderList.length > 0
        ? teamData.senderList
        : null,
  };

  const response = await apiClient.post('/v1/organizations/teams', payload, { withAuth: true });

  return response.data;
}
/**
 * 관리자 부서 리스트 조회
 * @param {number} companyId - 조회할 회사 ID
 * @returns {Promise<Object>} 서버 응답 데이터
 */
export async function getTeamByadmin(companyId) {
  const response = await apiClient.get(`/v1/organizations/${companyId}`, { withAuth: true });
  return response.data;
}
/**
 * 관리자 비활성화 부서 리스트 조회
 * @param {number} companyId - 조회할 회사 ID
 * @returns {Promise<Object>} 서버 응답 데이터
 */
export async function getAdminDisabledTeamList(companyId) {
  const response = await apiClient.get(`/v1/organizations/${companyId}/disabled`, {
    withAuth: true,
  });
  return response.data;
}
